import { requestBuilder } from '../../http/RequestBuilder';
import type { HolisticCategory } from '../types/BankAccount';

interface UpdateAccountBody {
    syncteraAccountId: string;
    nickname?: string;
    icon?: string;
    color?: string;
    holisticCategory?: HolisticCategory;
}

export const useUpdateAccount = requestBuilder.mutation<
    { success: true },
    UpdateAccountBody,
    { bankAccountId: string }
>({
    endpoint: ({ bankAccountId }) =>
        `/api/bank-accounts/account/${bankAccountId}`,
    method: 'PATCH',
});

export default useUpdateAccount;
